/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Checkout_InvalidInputs */

const en_orders_checkout_invalid = /** @type {(inputs: Orders_Checkout_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-out date/time is invalid.`)
};

const es_orders_checkout_invalid = /** @type {(inputs: Orders_Checkout_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La fecha y hora de salida no es valida.`)
};

/**
* | output |
* | --- |
* | "Check-out date/time is invalid." |
*
* @param {Orders_Checkout_InvalidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_checkout_invalid = /** @type {((inputs?: Orders_Checkout_InvalidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Checkout_InvalidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_checkout_invalid(inputs)
	return es_orders_checkout_invalid(inputs)
});